<template>
	<div>

		<div class="hr-form">
			<div class="form">
				<el-form :model="form" :rules="rules" ref="ruleForm">
					<h3> {{$t('Sign in/Sign up')}} </h3>
					<div class="selectdiv">
						<span @click="chcode" :class="code?'oncss':''"> {{ $t('Verification Code')}} </span>
						<span @click="chpass" :class="pass?'oncss':''">{{ $t('Passwordon')}} </span>
					</div>
					<el-form-item  prop="phone">
						<el-input  oninput="value=value.replace(/\D/gi,'')" :placeholder="$t('Phone number')" v-model="form.phone" :maxlength="max" class="wp-input input-with-select">
							<el-select v-model="form.countryIndex" slot="prepend" style="width: 120px" @change="changeCode"  >
								<div class="el-input_search">
									<img src="../assets/img/search.svg" />
									<input type="text" 
											:placeholder="$t('searchArea')" 
											class="el-input__inner" 
											v-model="dropDownValue" 
											@keyup="dropDownSearch">
								</div>

								<el-option v-for="(item, index) in countries" :label="`+${item.country_code } ${ item.name} `" :key="item.id" :value="item.id">
									<span>+{{item.country_code }} {{ item.name }}  </span>
								</el-option>
							</el-select>
						</el-input>
					</el-form-item>

					<el-form-item   v-if="code"  prop="verification" class="wp-item" >
							<el-input  maxlength="6"  :placeholder="$t('Verification code')" v-model="form.verification" oninput="value=value.replace(/\D/gi,'')" class="wp-input input-with-send">
								
								<el-button slot="append"  @click="submit">
									 <span v-if="time==0"> {{$t('Send')}} </span>
									 <span v-else>{{time}} s </span>
								</el-button>
							</el-input>
					</el-form-item>
				
					<div v-if="code" class="bytwo">
						<el-button class="wp-button primary" @click="verifyClick">{{ $t('Continue') }}</el-button>
					</div>

					<el-form-item  v-if="pass"  prop="password" class="wp-item" >
							<el-input   :type="flagType"   :placeholder="$t('Password')" v-model="form.password" class="wp-input input-with-send input-with-pass">
								<img @click="getFlag()" slot="suffix" :src="flag ? see:nosee" style="margin-top:20px;font-size:18px;cursor:pointer;padding-right:15px;width:14px;height:10px;" alt="">
							</el-input>
					</el-form-item>
				
					<div v-if="pass" class="bytwo">
						<el-button class="wp-button primary" @click="submitForm()">{{ $t('Continue') }}</el-button>
					</div>




					<div class="byone">
						<span class="message">{{ $t('By continuing you agree to our Terms of Use and Privacy Policy') }}</span>
					</div>
				</el-form>
			</div>
		</div>
		
	</div>
</template>

<script>
import { verifyCodeLogin ,recordClick,verifyCode, getCountries,passLogin,checkUser} from '../api';
	import { loadingData, EventBus ,getTimeZoneCity } from '../utils';
	import { setStore, getStore, keys } from '../store';
	import { setUser } from '../store/user';
	import { LoginRedirect } from '../services/redirectService';

	import i18n from '../locales/i18n';

	export default {
		data() {
			return {
				form: {
					phone: '',
					countryIndex: '',
					code:'',
					verification:'',
					password:'',
				},
				countries: [],
				min:1,
				rules: {
					phone: [
						{ required: true, message: i18n.t('Please enter your mobile phone number'), trigger: 'blur' },
						{ min:6, message: i18n.t('Incorrect mobile number format'), trigger: 'blur' },
					],
					verification:[
						{ required: true, message: i18n.t('Please enter the verification code'), trigger: 'blur'  },
						{ max:6,min:6, message: i18n.t('The verification code format is incorrect'), trigger: 'blur' },
					],
					password:[
						{required:true,message: i18n.t('Please enter the password'), trigger: 'blur' }
					]
				},
				status:null,
				max:10,
				time:0,
				code:true,
				pass:false,
				 flag: false,
				flagType:'password',
				see:require('../assets/img/nosee.png'),
				nosee:require('../assets/img/see.png'),
				dropDownValue:'',
				qvhao: [],
				
			};
		},
		created(){
			function gethtmlfontsize(){
				// 三个步骤:
				// 1.获取html的高,
				let htmlheight=document.documentElement.clientHeight || document.body.clientHeight;//有些浏览器documentElement获取不到,那就使用后面的body
				console.log( htmlheight);    
				// 2.htmlDom
				let htmlDom=document.getElementsByTagName("html")[0]
				// console.log(htmlDom);
				//3.设置根元素样式
				htmlDom.style.fontSize=100* htmlheight/375+'px';
				console.log(htmlDom.style.fontSize)
				htmlDom.style.height = '100%';
			}
				// 调用一次
				gethtmlfontsize();
				// 添加监听事件(resize是监听的意思)
				window.addEventListener('resize',gethtmlfontsize)
		},
		mounted() {
			loadingData(async () => {
				let result = await getCountries({});
				this.countries = result.map((item) => {
					return { id: item.id, name: item.title, country_code: item.country_code };
				});
				this.qvhao=this.countries
				 this.form.countryIndex = this.countries[0].id
                this.form.code = this.countries[0].country_code
			});
			let user= getStore(keys.user)
			if(user.user_info){
				this.$router.push({ path: '/index' });
			}
		},
		computed:{
			// status(){
			// 	return this.form.countryIndex==''?true:false
			// }
		},
		methods: {
			  getFlag(){
			this.flag = !this.flag
			this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
			},
			chcode(){
				this.code=true;
				this.pass=false;
				this.$refs.ruleForm.resetFields();
			},
			chpass(){
				this.code=false;
				this.pass=true;
				this.$refs.ruleForm.resetFields();
			},
			changeCode(){
        this.countries.map((item) => {
            if(this.form.countryIndex == item.id){
                this.form.code = item.country_code
            }
        });
        if(this.form.code=='86'){

		  if(this.form.phone.length>11){
            this.form.phone = ''
          }

          this.max = 11
		//   this.rules.phone[1].min = 1
        }else if(this.form.code=='1'){
          if(this.form.phone.length>10){
            this.form.phone = ''
          }
          this.max = 10

        }else{
			this.max=15

		}
      },
	     //验证码
			submit() {
				// this.countryFc()
				this.$refs.ruleForm.validateField ("phone", (valid) => {
					if (!valid) {
						if(this.time!=0){
							this.$message(i18n.t('还在有效期内'));
							return
						}
						loadingData(async () => {
							// let countryCode = this.form.code;
							let checkphone=await checkUser(this.form.phone, this.form.code);
						 console.log(checkphone)
						 if(checkphone.is_exist=='0'){

							//  this.$router.push({
							// 	name: 'newUser',
							// 	params: {
							// 		phone: this.form.phone,
							// 		country_code: this.form.code,
							// 	},
							// });
							this.$message({ 
								  message: i18n.t('User Does Not Exist'),
								  type: 'warning',
								  customClass:'messageclass',
								//   center: true
							  });
							return false
						 }
							await verifyCode(this.form.phone, this.form.code);
						 
							this.time=60;
							let distime= setInterval(() => {
								if(this.time==0){
									clearInterval(distime);
								}
								else{
								     this.time=this.time-1;
							    }
						}, 1000);
							// this.$router.push({
							// 	name: 'verify',
							// 	params: {
							// 		phone: this.form.phone,
							// 		country_code: this.form.code,
							// 	},
							// 	query: this.$route.query,
							// });
						});
					}
				});
			},
			//密码登录
			async  submitForm() {
				var that =this
				 await this.$refs.ruleForm.validate ((valid) => {
					if(valid){
						loadingData(async () => {
						try {	
							// alert(getTimeZoneCity())
							
						let userInfo = await passLogin(that.form.phone, that.form.password, that.form.code,getTimeZoneCity());
						if(!userInfo||userInfo==''||userInfo==null){
							return false
						}
						if(userInfo=='Password input error'){
							this.$message({ 
								  message: i18n.t('Wrong password'),
								  type: 'error',
								  customClass:'dismessageclass',
							  });
							return false
						}
						setStore(keys.userInfo, userInfo);
						setStore(keys.token, userInfo.token);
						await setUser();
						EventBus.$emit('login');

						if (userInfo.is_register){
							// await recordClick(2,userInfo.user_sn);
						}
						setTimeout(() => {
							// if (userInfo.is_register) 
							this.$router.push({ path: '/index' });
							// else {
							// 	LoginRedirect();
							// }
						}, 1000);
						}catch (error) {
						this.status = false;
					}
					
					});
					
					}
				});
				
				
			},
			//登录
			async  verifyClick() {
				var that =this
				 await this.$refs.ruleForm.validate ((valid) => {
					if(valid){
						loadingData(async () => {
						try {	
							// alert(getTimeZoneCity())
						let userInfo = await verifyCodeLogin(that.form.phone, that.form.verification, that.form.code,getTimeZoneCity());
						if(!userInfo||userInfo==''||userInfo==null){
							that.form.verification=''
							return false
						}
						setStore(keys.userInfo, userInfo);
						setStore(keys.token, userInfo.token);
						await setUser();
						EventBus.$emit('login');

						if (userInfo.is_register){
							// await recordClick(2,userInfo.user_sn);
						}
						setTimeout(() => {
							// if (userInfo.is_register) 
							this.$router.push({ path: '/index' });
							// else {
							// 	LoginRedirect();
							// }
						}, 1000);
						}catch (error) {
						this.status = false;
					}
					
					});
					
					}
				});
				
				
			},
			countryFc(){
				if(this.form.countryIndex==''){
					this.status=true;
					return false;
				}else{
					this.status=false
				}
			},
			dropDownSearch () {
				var _this = this
				if (_this.dropDownValue) {
					_this.countries = []
					_this.qvhao.find(item => {
					let name =  ' +' + item.country_code + item.name 
					if (name.toLowerCase().indexOf(_this.dropDownValue.toLowerCase()) != -1) {
						_this.countries.push(item)
					}
					})
				} else {
					_this.countries = _this.qvhao
				}
				},
		},
	};
</script>

<style lang="less" scoped>
	.oncss{
		color: #000000;
	}
	.title {
		font-family: Sofia Pro Bold;
		font-style: normal;
		font-weight: 700;
		font-size: 28px;
		
		color: #111827;
		text-align: center;
		margin-top: 153px;
		span{
			display: block;
			line-height: 42px;
		}
	}
	.smail-title{
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #6B7280;
		display: block;
		margin-top: 10px;
	}
	.hr-form{
		width: 592px;
		margin:0 auto;
		overflow: hidden;
		display: flex;
		flex-direction:column;
		justify-content:center;
		align-items:center;
		// margin-top:229px;
		// padding: 40px;
		// border-top: 1px solid  #E5E7EB;
	}

	.form {
		// box-sizing:border-box;
		width:1.8rem;
		// height: 342px;
		background: #FFFFFF;
		box-shadow: 0px 1px 30px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
		border-radius: 12px;
		padding: 0.13rem;
		input , span,/deep/.el-input__inner{
			font-family: 'Sofia Pro';
		}
		.selectdiv{
			font-weight: 500;
			font-size: 0.07rem;
			line-height:0.11rem;
			color: #B4BAC3;
			display: flex;
			justify-content:space-between;
			margin-bottom: 0.08rem;
			span{
				font-family: 'Sofia Pro';
				cursor:pointer;
			}
		}
		h3{
			font-family:  Sofia Pro SemiBold;
			font-style: normal;
			font-weight: 600;
			font-size: 0.08rem;
			line-height: 0.11rem;
			color: #111827;
			text-align: center;
			margin: 0 auto 0.08rem;
		}
		.message {
			font-family: 'Inter';
			font-style: normal;
			font-weight: 400;
			font-size: 0.05rem;
			line-height: 0.086rem;
			display: block;
			text-align: center;
			margin: 0.13rem auto 0;
			color: #6B7280;
		}
		.empty{
			color: #F56C6C;
			font-size: 12px;
			line-height: 1;
			padding-top: 4px;
			position: absolute;
			top: 100%;
			left: 0;
		}
	}
	/deep/.wp-button{
		font-family: 'Inter';
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 28px;
		padding: 10px 20px;
	}
	.byone{
			// margin-top: 150px;
		}
		/deep/.el-input /deep/.el-input--suffix/deep/ .el-input__inner{
		color: #000000;
	}
	
	@media screen and (max-width: @device){
		.title {
		font-family: Sofia Pro Bold;
		font-style: normal;
		font-weight: 700;
		font-size: 28px;
		
		color: #111827;
		text-align: center;
		margin-top: 153px;
		span{
			display: block;
			line-height: 42px;
		}
	}
	.smail-title{
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #6B7280;
		display: block;
		margin-top: 10px;
	}
	.hr-form{
		width: 592px;
		margin: 0 auto;
		margin-top:229px;
		padding: 40px;
		// border-top: 1px solid  #E5E7EB;
	}

	.form {
		// box-sizing:border-box;
		margin: 0px auto 80px;
		width: 448px;
		// height: 328px;
		background: #FFFFFF;
		box-shadow: 0px 1px 30px rgba(16, 24, 40, 0.1), 0px 1px 2px -1px rgba(16, 24, 40, 0.1);
		border-radius: 12px;
		padding: 32px;
		input , span,/deep/.el-input__inner{
			font-family: 'Sofia Pro';
		}
		.selectdiv{
			font-weight: 500;
			font-size: 16px;
			line-height: 28px;
			color: #B4BAC3;
			display: flex;
			justify-content:space-between;
			margin-bottom: 20px;
			span{
				font-family: 'Sofia Pro';
				cursor:pointer;
			}
		}
		h3{
			font-family:  Sofia Pro SemiBold;
			font-style: normal;
			font-weight: 600;
			font-size: 20px;
			line-height: 28px;
			color: #111827;
			text-align: center;
			margin: 0 auto 20px;
		}
		.message {
			font-family: 'Inter';
			font-style: normal;
			font-weight: 400;
			font-size: 12px;
			line-height: 20px;
			display: block;
			text-align: center;
			margin: 32px auto 0;
			color: #6B7280;
		}
		.empty{
			color: #F56C6C;
			font-size: 12px;
			line-height: 1;
			padding-top: 4px;
			position: absolute;
			top: 100%;
			left: 0;
		}
	}
	/deep/.wp-button{
		font-family: 'Inter';
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 28px;
		padding: 10px 20px;
	}
	.byone{
			// margin-top: 150px;
		}
		/deep/.el-input /deep/.el-input--suffix/deep/ .el-input__inner{
		color: #000000;
	}
		.title{
			margin-top:37px;
			font-weight: 700;
			font-size: 20px;
			line-height: 36px;
			  color: #111827;
			  font-family: Sofia Pro Bold;
		}
		.smail-title{
			width: 335px;
			margin: 10px auto 0;

		}
		.hr-form{
			width: 90%;
			margin: 0 auto;
			margin-top:20px;
			padding:  0px;
			padding-top: 128px;
			// border-top: 1px solid  #E5E7EB;
			.form{
				width: 81%;
			}
	   }
	   .byone{
		margin-top: 32px;
	   }
		
		.bytwo{
			margin-top: 10px;
		}
		.bytwo /deep/.el-button--default {
			font-weight: 500;
           font-size: 18px;
            line-height: 28px;
			font-family: Sofia Pro SemiBold;
		}
		/deep/.el-input__inner{
			color: #667085;
		}
		.wp-input input-with-select{
			color: #101828;
		}
		/deep/.el-form-item{
			margin-top: 20px;
		}
	}
	/deep/.el-input.is-active .el-input__inner, /deep/.el-input__inner:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus-within{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.wp-input .el-input-group__prepend{
		border-radius: 6px 0 0 6px;
		// border-right: none;
	}
	/deep/.el-input-group__prepend{
		background: #FFFFFF;
	}
	/deep/.input-with-send {
		input{
			border-radius:6px 0  0 6px;
			// border-right:none;
		}
	}
	/deep/.input-with-pass{
		input{
			border-radius: 6px;
		}
	}
	/deep/.input-with-select{
		border-radius:0 6px   6px 0 ;
		.el-input__inner{
			// border-left: 0;
		}
		// .el-input__inner:focus ,.is-error .el-input__inner {
		// 	border-left:1px solid;
		// }

	}
	
	/deep/.el-input__inner{
		border-radius:0 6px   6px 0 ;
	}
   /deep/.wp-item,/deep/.el-form-item__content{
	width: 100%;
	display: flex;
	flex-direction :row;
	// .wp-input{
	// 	width: 80%;
	// }

   }
   /deep/.wp-input{
	.el-input-group__append{
		background:  #FFFFFF;
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
		color: #4B69FE;

	}
   }
   /deep/.wp-input .el-input-group__append:focus-within{
	border: 1px  solid hsl(0, 0%, 0%);
   }
   /deep/ .wp-input .el-input-group__append:focus{
	border: 1px  solid hsl(0, 0%, 0%);
   }
@media screen and (min-width: @device){
		.form .selectdiv{
			display: flex;
			justify-content:space-around;
		}
		.el-form-item{
			margin-bottom: 0.088rem;
		}
		/deep/.wp-input{
			input{
				height: 0.2rem;
				font-size: 0.064rem;
			}
		}
		/deep/.el-button{
			padding:0.05rem
		}
		/deep/.wp-button{
		font-family: 'Inter';
		font-style: normal;
		font-weight: 500;
		font-size: 0.075rem;
		line-height: 0.13rem;
		padding: 0.04rem  0.08rem;
		height: 0.2rem;
		padding: 0;
	}
	/deep/.el-input__icon{
		line-height: 0.2rem;
	}
	.hr-form{
		height:calc(100vh - 110px);
	}
	}
	/* 搜索下拉框 */
.el-input_search{
  /* width:100%; */
  margin: 5px 20px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #353643;
}
.el-input_search input{
  border:none;
  background: none;
  font-family: Sofia Pro-Regular;
}
.el-input_search img{
  width:20px;
  height:20px;
}
.el-input_search input::-webkit-input-placeholder{
  color: #6e6e6e;
  font-family: Sofia Pro-Regular;
}
.el-input_search{
     .el-input__inner:focus,.el-input__inner{
       border: none;
     }
    /deep/.el-input__inner:focus{
      border: none;
    }

  }

</style>


// WEBPACK FOOTER //
// src/views/Login.vue